export const DATE_FORMAT = {
  TIME: 'HH:mm:ss',
  DAY: 'D일',
}
